const Publications = {
	"data": [
		{
			"id": "http://zotero.org/users/5729767/items/XY7PNSTI",
			"type": "article-journal",
			"abstract": "Universal health coverage is a national priority in Mexico, with active efforts to expand public healthcare system access, increase financial protection and improve quality of care. We estimated effective coverage of multiple conditions within the Mexican Institute of Social Security (IMSS), which covers 62 million individuals. We identified routinely collected performance indicators at IMSS from 2016 related to use and quality of care for conditions avertable with high-quality healthcare; where candidate indicators were available, we quantified need for service from a population-representative survey and calculated effective coverage as proportion of individuals in need who experience potential health gains. We assessed subnational inequality across 32 states, and we weighted conditions by relative contribution to national disease burden to estimate composite effective coverage. Conditions accounting for 51% of healthcare-avertable disability-adjusted life years lost in Mexico could be assessed: antenatal care, delivery care, newborn care, childhood diarrhoea, cardiovascular disease and diabetes. Estimated effective coverage ranged from a low of 27% for childhood diarrhoea to a high of 74% for newborn care. Substantial inequality in effective coverage existed between states, particularly for maternal and child conditions. Overall effective coverage of these six conditions in IMSS was 49% in 2016. Gaps in use and quality of care must be addressed to ensure good health for all in Mexico. Despite extensive monitoring of health status and services in Mexico, currently available data are inadequate to the task of fully and routinely assessing health system effective coverage. Leaders at IMSS and similar healthcare institutions must be more purposeful in planning the assessment of population need, utilization of care and quality impacts of care to enable linkage of these data and disaggregation by location or population sub-group. Only then can complex health systems be fairly and fully evaluated.",
			"container-title": "Health Policy and Planning",
			"DOI": "10.1093/heapol/czz105",
			"ISSN": "1460-2237",
			"issue": "Supplement_2",
			"journalAbbreviation": "Health Policy Plan",
			"language": "eng",
			"note": "PMID: 31723962",
			"page": "ii67-ii76",
			"source": "PubMed",
			"title": "Assessing health system performance: effective coverage at the Mexican Institute of Social Security",
			"title-short": "Assessing health system performance",
			"volume": "34",
			"author": [
				{
					"family": "Leslie",
					"given": "Hannah H."
				},
				{
					"family": "Doubova",
					"given": "Svetlana V."
				},
				{
					"family": "Pérez-Cuevas",
					"given": "Ricardo"
				}
			],
			"issued": {
				"date-parts": [
					[
						"2019",
						11,
						1
					]
				]
			}
		},
		{
			"id": "http://zotero.org/users/5729767/items/4X6BWYPM",
			"type": "article-journal",
			"abstract": "BACKGROUND: Quality improvement collaboratives (QICs) have been used to improve health care for decades. Evidence on QIC effectiveness has been reported, but systematic reviews to date have little information from low- and middle-income countries (LMICs). OBJECTIVE: To assess the effectiveness of QICs in LMICs. METHODS: We conducted a systematic review following Cochrane methods, the Grading of Recommendations Assessment, Development, and Evaluation (GRADE) approach for quality of evidence grading, and the Preferred Reporting Items for Systematic Reviews and Meta-analyses (PRISMA) statement for reporting. We searched published and unpublished studies between 1969 and March 2019 from LMICs. We included papers that compared usual practice with QICs alone or combined with other interventions. Pairs of reviewers independently selected and assessed the risk of bias and extracted data of included studies. To estimate strategy effectiveness from a single study comparison, we used the median effect size (MES) in the comparison for outcomes in the same outcome group. The primary analysis evaluated each strategy group with a weighted median and interquartile range (IQR) of MES values. In secondary analyses, standard random-effects meta-analysis was used to estimate the weighted mean MES and 95% confidence interval (CI) of the mean MES of each strategy group. This review is registered with PROSPERO (International Prospective Register of Systematic Reviews): CRD42017078108. RESULTS: Twenty-nine studies were included; most (21/29, 72.4%) were interrupted time series studies. Evidence quality was generally low to very low. Among studies involving health facility-based health care providers (HCPs), for \"QIC only\", effectiveness varied widely across outcome groups and tended to have little effect for patient health outcomes (median MES less than 2 percentage points for percentage and continuous outcomes). For \"QIC plus training\", effectiveness might be very high for patient health outcomes (for continuous outcomes, median MES 111.6 percentage points, range: 96.0 to 127.1) and HCP practice outcomes (median MES 52.4 to 63.4 percentage points for continuous and percentage outcomes, respectively). The only study of lay HCPs, which used \"QIC plus training\", showed no effect on patient care-seeking behaviors (MES -0.9 percentage points), moderate effects on non-care-seeking patient behaviors (MES 18.7 percentage points), and very large effects on HCP practice outcomes (MES 50.4 percentage points). CONCLUSIONS: The effectiveness of QICs varied considerably in LMICs. QICs combined with other invention components, such as training, tended to be more effective than QICs alone. The low evidence quality and large effect sizes for QIC plus training justify additional high-quality studies assessing this approach in LMICs.",
			"container-title": "PLoS One",
			"DOI": "10.1371/journal.pone.0221919",
			"ISSN": "1932-6203",
			"issue": "10",
			"page": "e0221919",
			"title": "The effectiveness of the quality improvement collaborative strategy in low- and middle-income countries: A systematic review and meta-analysis",
			"volume": "14",
			"author": [
				{
					"family": "Garcia-Elorrio",
					"given": "Ezequiel"
				},
				{
					"family": "Rowe",
					"given": "Samantha Y"
				},
				{
					"family": "Teijeiro",
					"given": "Maria E"
				},
				{
					"family": "Ciapponi",
					"given": "Agustín"
				},
				{
					"family": "Rowe",
					"given": "Alexander K."
				}
			],
			"issued": {
				"date-parts": [
					[
						"2019"
					]
				]
			}
		},
		{
			"id": "http://zotero.org/users/5729767/items/9M28QJAU",
			"type": "article-journal",
			"abstract": "High-performing primary health care (PHC) is essential for achieving universal health coverage. However, in many countries, PHC is weak and unable to deliver on its potential. Improvement is often limited by a lack of actionable data to inform policies and set priorities. To address this gap, the Primary Health Care Performance Initiative (PHCPI) was formed to strengthen measurement of PHC in low-income and middle-income countries in order to accelerate improvement. PHCPI’s Vital Signs Profile was designed to provide a comprehensive snapshot of the performance of a country’s PHC system, yet quantitative information about PHC systems’ capacity to deliver high-quality, effective care was limited by the scarcity of existing data sources and metrics. To systematically measure the capacity of PHC systems, PHCPI developed the PHC Progression Model, a rubric-based mixed-methods assessment tool. The PHC Progression Model is completed through a participatory process by in-country teams and subsequently reviewed by PHCPI to validate results and ensure consistency across countries. In 2018, PHCPI partnered with five countries to pilot the tool and found that it was feasible to implement with fidelity, produced valid results, and was highly acceptable and useful to stakeholders. Pilot results showed that both the participatory assessment process and resulting findings yielded novel and actionable insights into PHC strengths and weaknesses. Based on these positive early results, PHCPI will support expansion of the PHC Progression Model to additional countries to systematically and comprehensively measure PHC system capacity in order to identify and prioritise targeted improvement efforts.",
			"container-title": "BMJ Glob Health",
			"DOI": "10.1136/bmjgh-2019-001822",
			"ISSN": "2059-7908",
			"issue": "5",
			"page": "e001822",
			"title": "PHC Progression Model: a novel mixed-methods tool for measuring primary health care system capacity",
			"volume": "4",
			"author": [
				{
					"family": "Ratcliffe",
					"given": "Hannah L"
				},
				{
					"family": "Schwarz",
					"given": "Dan"
				},
				{
					"family": "Hirschhorn",
					"given": "Lisa R."
				},
				{
					"family": "Cejas",
					"given": "Cintia"
				},
				{
					"family": "Diallo",
					"given": "Abdoulaye"
				},
				{
					"family": "Elorrio",
					"given": "Ezequiel Garcia"
				},
				{
					"family": "Fifield",
					"given": "Jocelyn"
				},
				{
					"family": "Gashumba",
					"given": "Diane"
				},
				{
					"family": "Hartshorn",
					"given": "Lucy"
				},
				{
					"family": "Leydon",
					"given": "Nicholas"
				},
				{
					"family": "Mohamed",
					"given": "Mohamed"
				},
				{
					"family": "Nakamura",
					"given": "Yoriko"
				},
				{
					"family": "Ndiaye",
					"given": "Youssoupha"
				},
				{
					"family": "Novignon",
					"given": "Jacob"
				},
				{
					"family": "Ofosu",
					"given": "Anthony"
				},
				{
					"family": "Roder-DeWan",
					"given": "Sanam"
				},
				{
					"family": "Rwiyereka",
					"given": "Angelique"
				},
				{
					"family": "Secci",
					"given": "Federica"
				},
				{
					"family": "Veillard",
					"given": "Jeremy H"
				},
				{
					"family": "Bitton",
					"given": "Asaf"
				}
			],
			"issued": {
				"date-parts": [
					[
						"2019"
					]
				]
			}
		},
		{
			"id": "http://zotero.org/users/5729767/items/LQZMEA5J",
			"type": "article-journal",
			"abstract": "OBJECTIVE: In Peru, the past three decades have witnessed impressive growth in biomedical research catalyzed from a single research university and its investigators who secured international partnerships and funding. We conducted a bibliometric analysis of publications by Peruvian authors to understand the roots of this growth and the spread of research networks within the country. METHODS: For 1997-2016, publications from Web of Science with at least one author affiliated with a Peruvian institution were examined by year, author affiliations, funding agencies, co-authorship linkages, and research topics. RESULTS: From 1997-2016, the annual number of publications from Peru increased 9-fold from 75 to 672 totaling 6032. Of these, 56% of the articles had co-authors from the US, 13% from the UK, 12% from Brazil, and 10% from Spain. Universidad Peruana Cayetano Heredia (UPCH) was clearly the lead research institution noted on one-third of publications. Of the 20 most published authors, 15 were Peruvians, 14 trained at some point at UPCH, and 13 received advanced training abroad. Plotting co-authorships documented the growth of institutional collaborations, the robust links between investigators and some lineages of mentorship. CONCLUSIONS: This analysis suggests that international training of Peruvian physician-scientists who built and sustained longstanding international partnerships with funding accelerated quality research on diseases of local importance. The role of a single research university, UPCH, was critical to advance a culture of biomedical research. Increased funding from the Peruvian Government and its Council for Science, Technology and Innovation will be needed to sustain this growth in the future. Middle-income countries might consider the Peruvian experience where long-term research and training partnerships yielded impressive advances to address key health priorities of the country.",
			"container-title": "PLoS Negl Trop Dis",
			"DOI": "10.1371/journal.pntd.0007483",
			"ISSN": "1935-2735",
			"issue": "7",
			"page": "e0007483",
			"title": "The catalytic role of a research university and international partnerships in building research capacity in Peru: A bibliometric analysis",
			"volume": "13",
			"author": [
				{
					"family": "Belter",
					"given": "Christopher W"
				},
				{
					"family": "Garcia",
					"given": "Patricia J"
				},
				{
					"family": "Livinski",
					"given": "Alicia A"
				},
				{
					"family": "Leon-Velarde",
					"given": "Fabiola"
				},
				{
					"family": "Weymouth",
					"given": "Kristen H"
				},
				{
					"family": "Glass",
					"given": "Roger I"
				}
			],
			"issued": {
				"date-parts": [
					[
						"2019"
					]
				]
			}
		},
		{
			"id": "http://zotero.org/users/5729767/items/5YNX5PQG",
			"type": "article-journal",
			"abstract": "OBJECTIVE: This study aimed to investigate factors associated with patient experience with primary care in a large public health system in Mexico and determine the amount of variability in experience attributable to facility-level and state-level factors.\nMETHODS: We analysed cross-sectional 2016 national satisfaction survey data from the Mexican Social Security Institute (IMSS). Patient-level data were merged with facility-level data and information on poverty by state. We assessed general contextual effects and examined the relationship of patient, facility and state factors with four patient experience measures using random effects logistic regression.\nRESULTS: 25 745 patients' responses from 319 facilities were analysed. The majority experienced good communication (78%), the opportunity to share health concerns (91%) and resolution of doubts (85%). 29% of visits were rated as excellent. Differences between facilities and states accounted for up to 12% and 6% of the variation in patient experience, respectively. Inclusion of facility-level contextual effects improved model predictions by 8%-12%; models with facility random effects and individual covariates correctly predicted 64%-71% of individual outcomes. In adjusted models, larger patient population was correlated with worse reported communication, less opportunity to share concerns and less resolution of doubts. Men reported more positive communication; older individuals reported more positive communication and experiences overall, but less opportunity to share concerns; and more educated individuals were less likely to report positive communication but more likely to report resolution of doubts and overall positive experiences. Preventive care visits were rated higher than curative visits for resolution of doubts, but lower for opportunity to share concerns, and specific conditions were associated with better or worse reported experiences in some cases.\nCONCLUSION: Quality improvement efforts at IMSS facilities might bolster individual experiences with primary care, given that up to 12% of the variation in experience was attributable to facility-level differences. The relationship between individual characteristics and experience ratings reinforces the importance of patients' expectations of care and the potential for differential treatment by providers to impact experience.",
			"container-title": "BMJ open",
			"DOI": "10.1136/bmjopen-2019-029818",
			"ISSN": "2044-6055",
			"issue": "1",
			"journalAbbreviation": "BMJ Open",
			"language": "eng",
			"note": "PMID: 31941761\nPMCID: PMC7045193",
			"page": "e029818",
			"source": "PubMed",
			"title": "Factors associated with positive user experience with primary healthcare providers in Mexico: a multilevel modelling approach using national cross-sectional data",
			"title-short": "Factors associated with positive user experience with primary healthcare providers in Mexico",
			"volume": "10",
			"author": [
				{
					"family": "Holt",
					"given": "Kelsey"
				},
				{
					"family": "Doubova",
					"given": "Svetlana V."
				},
				{
					"family": "Lee",
					"given": "Dennis"
				},
				{
					"family": "Perez-Cuevas",
					"given": "Ricardo"
				},
				{
					"family": "Leslie",
					"given": "Hannah H."
				}
			],
			"issued": {
				"date-parts": [
					[
						"2020",
						1,
						14
					]
				]
			}
		},
		{
			"id": "http://zotero.org/users/5729767/items/UNCAF7CV",
			"type": "article-journal",
			"abstract": "BACKGROUND: Antibiotic resistance is a major threat to global health. Although detailed information about antibiotic use in high-income countries is available, little is known regarding the use of antibiotics and cumulative exposure to antibiotics in low-income and middle-income countries (LMICs). We aimed to quantify antibiotic exposure in children younger than 5 years in LMICs.\nMETHODS: We did a cross-sectional study in sick children younger than 5 years who attended a health-care facility in eight LMICs (Haiti, Kenya, Malawi, Namibia, Nepal, Senegal, Tanzania, and Uganda) between May, 2006, and December, 2016. Demographic and Health Surveys were used to estimate the cumulative number of illnesses related to a fever or cough and the cumulative number of visits to a health-care facility because of these illnesses for each country. We also used clinical observation data from nationally representative health-care facility-based Service Provision Assessment (SPA) surveys to estimate the proportion of children who were prescribed an antibiotic during a visit to a health-care facility and the number of antibiotic prescriptions issued that were unrelated to fever or respiratory problems. By combining these estimates, and using bootstrap analysis to compute uncertainty intervals, we estimated cumulative antibiotic exposure in children from birth up to age 5 years in each LMIC.\nFINDINGS: From SPA surveys, we identified 22 519 clinical observations of children younger than 5 years who visited a health-care facility because of an illness between July, 2007, and December, 2016. From DHS surveys, we identified 68 826 children younger than 5 years who visited a health-care facility between May, 2006, and November, 2016. 85·4% of health-care facility visits were related to either a fever or cough. Antibiotics were prescribed to 80·5% of children diagnosed with respiratory illness, 50·1% with diarrhoea, and 28·3% with malaria. The mean number of antibiotic prescriptions issued to children between birth and age 5 years across the eight LMICs was 24·5 (95% CI 22·6-26·7), ranging from 7·1 (6·3-7·9) in Senegal to 59·1 (54·1-64·6) in Uganda.\nINTERPRETATION: Between birth and age 5 years, children in LMICs are prescribed a remarkably high number of antibiotics. A large proportion of these prescriptions appear to be unnecessary. National and local efforts to reduce unnecessary prescription of antibiotics to children would likely improve both patient wellbeing (in terms of preventing side-effects) and reduce the global threat of antimicrobial resistance.\nFUNDING: None.",
			"container-title": "The Lancet. Infectious Diseases",
			"DOI": "10.1016/S1473-3099(19)30572-9",
			"ISSN": "1474-4457",
			"issue": "2",
			"journalAbbreviation": "Lancet Infect Dis",
			"language": "eng",
			"note": "PMID: 31843383",
			"page": "179-187",
			"source": "PubMed",
			"title": "Antibiotic exposure among children younger than 5 years in low-income and middle-income countries: a cross-sectional study of nationally representative facility-based and household-based surveys",
			"title-short": "Antibiotic exposure among children younger than 5 years in low-income and middle-income countries",
			"volume": "20",
			"author": [
				{
					"family": "Fink",
					"given": "Günther"
				},
				{
					"family": "D'Acremont",
					"given": "Valérie"
				},
				{
					"family": "Leslie",
					"given": "Hannah H."
				},
				{
					"family": "Cohen",
					"given": "Jessica"
				}
			],
			"issued": {
				"date-parts": [
					[
						"2020",
						2
					]
				]
			}
		},
		{
			"id": "http://zotero.org/users/5729767/items/D43CM747",
			"type": "article-journal",
			"abstract": "BACKGROUND: Healthcare is amongst the most complex of human systems. Coordinating activities and integrating newer with older ways of treating patients while delivering high-quality, safe care, is challenging. Three landmark reports in 2018 led by (1) the Lancet Global Health Commission, (2) a coalition of the World Health Organization, the Organisation for Economic Co-operation and Development and the World Bank, and (3) the National Academies of Sciences, Engineering and Medicine of the United States propose that health systems need to tackle care quality, create less harm and provide universal health coverage in all nations, but especially low- and middle-income countries. The objective of this study is to review these reports with the aim of advancing the discussion beyond a conceptual diagnosis of quality gaps into identification of practical opportunities for transforming health systems by 2030. MAIN BODY: We analysed the reports via text-mining techniques and content analyses to derive their key themes and concepts. Initiatives to make progress include better measurement, using the capacities of information and communications technologies, taking a systems view of change, supporting systems to be constantly improving, creating learning health systems and undergirding progress with effective research and evaluation. Our analysis suggests that the world needs to move from 2018, the year of reports, to the 2020s, the decade of action. We propose three initiatives to support this move: first, developing a blueprint for change, modifiable to each country’s circumstances, to give effect to the reports’ recommendations; second, to make tangible steps to reduce inequities within and across health systems, including redistributing resources to areas of greatest need; and third, learning from what goes right to complement current efforts focused on reducing things going wrong. We provide examples of targeted funding which would have major benefits, reduce inequalities, promote universality and be better at learning from successes as well as failures. CONCLUSION: The reports contain many recommendations, but lack an integrated, implementable, 10-year action plan for the next decade to give effect to their aims to improve care to the most vulnerable, save lives by providing high-quality healthcare and shift to measuring and ensuring better systems- and patient-level outcomes. This article signals what needs to be done to achieve these aims.",
			"container-title": "BMC Med",
			"DOI": "10.1186/s12916-020-01739-y",
			"ISSN": "1741-7015",
			"issue": "1",
			"page": "340",
			"title": "Transformational improvement in quality care and health systems: the next decade",
			"volume": "18",
			"author": [
				{
					"family": "Braithwaite",
					"given": "Jeffrey"
				},
				{
					"family": "Vincent",
					"given": "Charles"
				},
				{
					"family": "Garcia-Elorrio",
					"given": "Ezequiel"
				},
				{
					"family": "Imanaka",
					"given": "Yuichi"
				},
				{
					"family": "Nicklin",
					"given": "Wendy"
				},
				{
					"family": "Sodzi-Tettey",
					"given": "Sodzi"
				},
				{
					"family": "Bates",
					"given": "David W"
				}
			],
			"issued": {
				"date-parts": [
					[
						"2020"
					]
				]
			}
		},
		{
			"id": "http://zotero.org/users/5729767/items/PZ42X39C",
			"type": "article-journal",
			"abstract": "BACKGROUND: In Peru, a majority of individuals bypass primary care facilities even for routine services. Efforts to strengthen primary care must be informed by understanding of current practice. We conducted a time motion assessment in primary care facilities in Lima with the goals of assessing the feasibility of this method in an urban health care setting in Latin America and of providing policy makers with empirical evidence on the use of health care provider time in primary care.\nMETHODS: This cross-sectional continuous observation time motion study took place from July - September 2019. We used two-stage sampling to draw a sample of shifts for doctors, nurses, and midwives in primary health facilities and applied the Work Observation Method by Activity Timing tool to capture type and duration of provider activities over a 6-h shift. We summarized time spent on patient care, paper and electronic record-keeping, and non-work (personal and inactive) activities across provider cadres. Observations are weighted by inverse probability of selection.\nRESULTS: Two hundred seventy-five providers were sampled from 60 facilities; 20% could not be observed due to provider absence (2% schedule error, 8% schedule change, 10% failure to appear). One hundred seventy-four of the 220 identified providers consented (79.1%) and were observed for a total of 898 h of provider time comprising 30,312 unique tasks. Outpatient shifts included substantial time on patient interaction (110, 82, and 130 min for doctors, nurses, and midwives respectively) and on paper records (132, 97, and 141 min) on average. Across all shifts, 1 in 6 h was spent inactive or on personal activities. Two thirds of midwives used computers compared to half of nurses and one third of doctors.\nCONCLUSIONS: The time motion study is a feasible method to capture primary care operations in Latin American countries and inform health system strengthening. In the case of Lima, absenteeism undermines health worker availability in primary care facilities, and inactive time further erodes health workforce availability. Productive time is divided between patient-facing activities and a substantial burden of paper-based record keeping for clinical and administrative purposes. Electronic health records remain incompletely integrated within routine care, particularly beyond midwifery.",
			"container-title": "BMC health services research",
			"DOI": "10.1186/s12913-021-06117-9",
			"ISSN": "1472-6963",
			"issue": "1",
			"journalAbbreviation": "BMC Health Serv Res",
			"language": "eng",
			"note": "PMID: 33549079\nPMCID: PMC7865111",
			"page": "123",
			"source": "PubMed",
			"title": "Health care provider time in public primary care facilities in Lima, Peru: a cross-sectional time motion study",
			"title-short": "Health care provider time in public primary care facilities in Lima, Peru",
			"volume": "21",
			"author": [
				{
					"family": "Leslie",
					"given": "Hannah H."
				},
				{
					"family": "Laos",
					"given": "Denisse"
				},
				{
					"family": "Cárcamo",
					"given": "Cesar"
				},
				{
					"family": "Pérez-Cuevas",
					"given": "Ricardo"
				},
				{
					"family": "García",
					"given": "Patricia J."
				}
			],
			"issued": {
				"date-parts": [
					[
						"2021",
						2,
						6
					]
				]
			}
		},
		{
			"id": "http://zotero.org/users/5729767/items/V5WCJVS7",
			"type": "article-journal",
			"abstract": "OBJECTIVE: To assess existing knowledge related to methodological considerations for linking population-based surveys and health facility data to generate effective coverage estimates. Effective coverage estimates the proportion of individuals in need of an intervention who receive it with sufficient quality to achieve health benefit.\nDESIGN: Systematic review of available literature.\nDATA SOURCES: Medline, Carolina Population Health Center and Demographic and Health Survey publications and handsearch of related or referenced works of all articles included in full text review. The search included publications from 1 January 2000 to 29 March 2021.\nELIGIBILITY CRITERIA: Publications explicitly evaluating (1) the suitability of data, (2) the implications of the design of existing data sources and (3) the impact of choice of method for combining datasets to obtain linked coverage estimates.\nRESULTS: Of 3805 papers reviewed, 70 publications addressed relevant issues. Limited data suggest household surveys can be used to identify sources of care, but their validity in estimating intervention need was variable. Methods for collecting provider data and constructing quality indices were diverse and presented limitations. There was little empirical data supporting an association between structural, process and outcome quality. Few studies addressed the influence of the design of common data sources on linking analyses, including imprecise household geographical information system data, provider sampling design and estimate stability. The most consistent evidence suggested under certain conditions, combining data based on geographical proximity or administrative catchment (ecological linking) produced similar estimates to linking based on the specific provider utilised (exact match linking).\nCONCLUSIONS: Linking household and healthcare provider data can leverage existing data sources to generate more informative estimates of intervention coverage and care. However, existing evidence on methods for linking data for effective coverage estimation are variable and numerous methodological questions remain. There is need for additional research to develop evidence-based, standardised best practices for these analyses.",
			"container-title": "BMJ open",
			"DOI": "10.1136/bmjopen-2020-045704",
			"ISSN": "2044-6055",
			"issue": "8",
			"journalAbbreviation": "BMJ Open",
			"language": "eng",
			"note": "PMID: 34446481\nPMCID: PMC8395298",
			"page": "e045704",
			"source": "PubMed",
			"title": "Methodological considerations for linking household and healthcare provider data for estimating effective coverage: a systematic review",
			"title-short": "Methodological considerations for linking household and healthcare provider data for estimating effective coverage",
			"volume": "11",
			"author": [
				{
					"family": "Carter",
					"given": "Emily D."
				},
				{
					"family": "Leslie",
					"given": "Hannah H."
				},
				{
					"family": "Marchant",
					"given": "Tanya"
				},
				{
					"family": "Amouzou",
					"given": "Agbessi"
				},
				{
					"family": "Munos",
					"given": "Melinda K."
				}
			],
			"issued": {
				"date-parts": [
					[
						"2021",
						8,
						26
					]
				]
			}
		},
		{
			"id": "http://zotero.org/users/5729767/items/YLA9PCPQ",
			"type": "article-journal",
			"abstract": "The Covid-19 and other recent pandemics has highlighted existing weakness in health systems across the Latin-America and the Caribbean (LAC) region to effectively prepare for and respond to Public Health Emergencies. It has been stated that quality of care will be among the most influential factors on Covid 19 mortality rates and low systems performance is the common case in these countries. More comprehensive and system level strategies are required to address the challenges. These must focus on redesigning and strengthening health systems to make them more resilient to the changing needs of populations and based on quality improvement methods that have shown rigorously evaluated positive effects in previous local and regional experiences. A call to action is being made by the Latin American Consortium for Quality, Patient Safety and Innovation (CLICSS) and they provide specific recommendations for decision makers.",
			"container-title": "Int J Qual Health Care",
			"DOI": "10.1093/intqhc/mzaa062",
			"ISSN": "1464-3677",
			"issue": "1",
			"title": "The COVID-19 pandemic: A call to action for health systems in Latin America to strengthen quality of care",
			"volume": "33",
			"author": [
				{
					"family": "Ezequiel",
					"given": "Garcia Elorrio"
				},
				{
					"family": "Jafet",
					"given": "Arrieta"
				},
				{
					"family": "Hugo",
					"given": "Arce"
				},
				{
					"family": "Pedro",
					"given": "Delgado"
				},
				{
					"family": "Ana Maria",
					"given": "Malik"
				},
				{
					"family": "Carola",
					"given": "Orrego Villagran"
				},
				{
					"family": "Sofia",
					"given": "Rincon"
				},
				{
					"family": "Odet",
					"given": "Sarabia"
				},
				{
					"family": "Teresa",
					"given": "Tono"
				},
				{
					"family": "Jorge",
					"given": "Hermida"
				},
				{
					"family": "Enrique",
					"given": "Ruelas Barajas"
				}
			],
			"issued": {
				"date-parts": [
					[
						"2021",
						3,
						5
					]
				]
			}
		},
		{
			"id": "http://zotero.org/users/5729767/items/QVD6YKBP",
			"type": "article-journal",
			"abstract": "To estimate the cost of six different techniques used to treat Genital Warts and the annual average cost of treating a typical GW patient in Peru. To estimate the annual economic burden diagnosing and treating GW in the Peruvian public healthcare system.",
			"container-title": "BMC Health Services Research",
			"DOI": "10.1186/s12913-021-07120-w",
			"ISSN": "1472-6963",
			"issue": "1",
			"journalAbbreviation": "BMC Health Services Research",
			"page": "1092",
			"source": "BioMed Central",
			"title": "The Annual costs of treating genital warts in the Public Healthcare Sector in Peru",
			"URL": "https://doi.org/10.1186/s12913-021-07120-w",
			"volume": "21",
			"author": [
				{
					"family": "Saldarriaga",
					"given": "Enrique M."
				},
				{
					"family": "Cárcamo",
					"given": "Cesar P."
				},
				{
					"family": "Babigumira",
					"given": "Joseph B."
				},
				{
					"family": "García",
					"given": "Patricia J."
				}
			],
			"accessed": {
				"date-parts": [
					[
						"2024",
						8,
						15
					]
				]
			},
			"issued": {
				"date-parts": [
					[
						"2021",
						10,
						14
					]
				]
			}
		},
		{
			"id": "http://zotero.org/users/5729767/items/B8JQDW7A",
			"type": "article-journal",
			"abstract": "INTRODUCTION: The COVID-19 pandemic has disrupted health systems around the world. The objectives of this study are to estimate the overall effect of the pandemic on essential health service use and outcomes in Mexico, describe observed and predicted trends in services over 24 months, and to estimate the number of visits lost through December 2020.\nMETHODS: We used health information system data for January 2019 to December 2020 from the Mexican Institute of Social Security (IMSS), which provides health services for more than half of Mexico's population-65 million people. Our analysis includes nine indicators of service use and three outcome indicators for reproductive, maternal and child health and non-communicable disease services. We used an interrupted time series design and linear generalised estimating equation models to estimate the change in service use and outcomes from April to December 2020. Estimates were expressed using average marginal effects on the risk ratio scale.\nRESULTS: The study found that across nine health services, an estimated 8.74 million patient visits were lost in Mexico. This included a decline of over two thirds for breast and cervical cancer screenings (79% and 68%, respectively), over half for sick child visits and female contraceptive services, approximately one-third for childhood vaccinations, diabetes, hypertension and antenatal care consultations, and a decline of 10% for deliveries performed at IMSS. In terms of patient outcomes, the proportion of patients with diabetes and hypertension with controlled conditions declined by 22% and 17%, respectively. Caesarean section rate did not change.\nCONCLUSION: Significant disruptions in health services show that the pandemic has strained the resilience of the Mexican health system and calls for urgent efforts to resume essential services and plan for catching up on missed preventive care even as the COVID-19 crisis continues in Mexico.",
			"container-title": "BMJ global health",
			"DOI": "10.1136/bmjgh-2021-006204",
			"ISSN": "2059-7908",
			"issue": "9",
			"journalAbbreviation": "BMJ Glob Health",
			"language": "eng",
			"note": "PMID: 34470746\nPMCID: PMC8413469",
			"page": "e006204",
			"source": "PubMed",
			"title": "Disruption in essential health services in Mexico during COVID-19: an interrupted time series analysis of health information system data",
			"title-short": "Disruption in essential health services in Mexico during COVID-19",
			"volume": "6",
			"author": [
				{
					"family": "Doubova",
					"given": "Svetlana V."
				},
				{
					"family": "Leslie",
					"given": "Hannah H."
				},
				{
					"family": "Kruk",
					"given": "Margaret E."
				},
				{
					"family": "Pérez-Cuevas",
					"given": "Ricardo"
				},
				{
					"family": "Arsenault",
					"given": "Catherine"
				}
			],
			"issued": {
				"date-parts": [
					[
						"2021",
						9
					]
				]
			}
		},
		{
			"id": "http://zotero.org/users/5729767/items/2CI9KVJR",
			"type": "article-journal",
			"abstract": "BACKGROUND: Recovery of health services disrupted by the COVID-19 pandemic represents a significant challenge in low- and middle-income countries. In April 2021, the Mexican Institute of Social Security (IMSS), which provides health care to 68.5 million people, launched the National Strategy for Health Services Recovery (Recovery policy). The study objective was to evaluate whether the Recovery policy addressed COVID-related declines in maternal, child health, and non-communicable diseases (NCDs) services.\nMETHODS: We analysed the data of 35 IMSS delegations from January 2019 to November 2021 on contraceptive visits, antenatal care consultations, deliveries, caesarean sections, sick children's consultations, child vaccination, breast and cervical cancer screening, diabetes and hypertension consultations, and control. We focused on the period before (April 2020 - March 2021) and during (April 2021 - November 2021) the Recovery policy and used an interrupted time series design and Poisson Generalized Estimating Equation models to estimate the association of this policy with service use and outcomes and change in their trends.\nRESULTS: Despite the third wave of the pandemic in 2021, service utilization increased in the Recovery period, reaching (at minimum) 49% of pre-pandemic levels for sick children's consultations and (at maximum) 106% of pre-pandemic levels for breast cancer screenings. Evidence for the Recovery policy role was mixed: the policy was associated with increased facility deliveries (IRR = 1.15, 95%CI = 1.11-1.19) with a growing trend over time (IRR = 1.04, 95%CI = 1.03-1.05); antenatal care and child health services saw strong level effects but decrease over time. Additionally, the Recovery policy was associated with diabetes and hypertension control. Services recovery varied across delegations.\nCONCLUSIONS: Health service utilization and NCDs control demonstrated important gains in 2021, but evidence suggests the policy had inconsistent effects across services and decreasing impact over time. Further efforts to strengthen essential health services and ensure consistent recovery across delegations are warranted.",
			"container-title": "Journal of Global Health",
			"DOI": "10.7189/jogh.12.05033",
			"ISSN": "2047-2986",
			"journalAbbreviation": "J Glob Health",
			"language": "eng",
			"note": "PMID: 35866236\nPMCID: PMC9304921",
			"page": "05033",
			"source": "PubMed",
			"title": "The road to recovery: an interrupted time series analysis of policy intervention to restore essential health services in Mexico during the COVID-19 pandemic",
			"title-short": "The road to recovery",
			"volume": "12",
			"author": [
				{
					"family": "Doubova",
					"given": "Svetlana V."
				},
				{
					"family": "Arsenault",
					"given": "Catherine"
				},
				{
					"family": "Contreras-Sánchez",
					"given": "Saul E."
				},
				{
					"family": "Borrayo-Sánchez",
					"given": "Gabriela"
				},
				{
					"family": "Leslie",
					"given": "Hannah H."
				}
			],
			"issued": {
				"date-parts": [
					[
						"2022",
						7,
						23
					]
				]
			}
		},
		{
			"id": "http://zotero.org/users/5729767/items/VJEBEKX9",
			"type": "article-journal",
			"container-title": "BMJ global health",
			"DOI": "10.1136/bmjgh-2021-008099",
			"ISSN": "2059-7908",
			"issue": "3",
			"journalAbbreviation": "BMJ Glob Health",
			"language": "eng",
			"note": "PMID: 35260393\nPMCID: PMC8905410",
			"page": "e008099",
			"source": "PubMed",
			"title": "Overcoming disruptions in essential health services during the COVID-19 pandemic in Mexico",
			"volume": "7",
			"author": [
				{
					"family": "Doubova",
					"given": "Svetlana V."
				},
				{
					"family": "Robledo-Aburto",
					"given": "Zoé Alejandro"
				},
				{
					"family": "Duque-Molina",
					"given": "Célida"
				},
				{
					"family": "Borrayo-Sánchez",
					"given": "Gabriela"
				},
				{
					"family": "González-León",
					"given": "Margot"
				},
				{
					"family": "Avilés-Hernández",
					"given": "Ricardo"
				},
				{
					"family": "Contreras-Sánchez",
					"given": "Saúl Eduardo"
				},
				{
					"family": "Leslie",
					"given": "Hannah H."
				},
				{
					"family": "Kruk",
					"given": "Margaret"
				},
				{
					"family": "Pérez-Cuevas",
					"given": "Ricardo"
				},
				{
					"family": "Arsenault",
					"given": "Catherine"
				}
			],
			"issued": {
				"date-parts": [
					[
						"2022",
						3
					]
				]
			}
		},
		{
			"id": "http://zotero.org/users/5729767/items/KVWXQ7JH",
			"type": "article-journal",
			"abstract": "BACKGROUND: Patient-reported measures attempt to quantify the value health services provide to users. Satisfaction is a common summative measure, but often has limited utility in identifying poor quality care. We compared satisfaction and the net promoter score (NPS), which was developed to help businesses quantify consumer sentiment, in a nationally representative survey in Peru. We aimed to compare NPS and satisfaction as individual ratings of care, assess the relationship of patient-reported experience ratings to these outcome measures and consider the utility of these measures as indicators of facility performance based on reliability within facilities and capacity to discriminate between facilities.\nMETHODS: We analysed the 2016 National Survey on User Satisfaction of Health Services, a cross-sectional outpatient exit survey. We assessed ratings by patient characteristics and compared the distributions of satisfaction and NPS categories. We tested the association of patient-reported experience measures with each outcome using multilevel ordinal logistic regression. We used intraclass correlation (ICC) from these models to predict minimum sample for reliable assessment and compared patient-reported experience measures in facilities with average satisfaction but below or above average NPS.\nRESULTS: 13 434 individuals rated services at 184 facilities. Satisfaction (74% satisfied) and NPS (17% reported at least 9 out of 10) were largely concordant within individuals but weakly correlated (0.37). Ratings varied by individual factors such as age and visit purpose. Most domains of patient-reported experience were associated with both outcomes. Adjusted ICC was higher for NPS (0.26 vs 0.11), requiring a minimum of 7 (vs 20) respondents for adequate reliability. Within the 70% of facilities classified as average based on satisfaction, NPS-based classification revealed systematic differences in patient-reported experience measures.\nCONCLUSION: While satisfaction and NPS were broadly similar at an individual level, this evidence suggests NPS may be useful for benchmarking facility performance as part of national efforts in Peru and throughout Latin America to identify deficits in health service quality.",
			"container-title": "BMJ quality & safety",
			"DOI": "10.1136/bmjqs-2021-014095",
			"ISSN": "2044-5423",
			"issue": "8",
			"journalAbbreviation": "BMJ Qual Saf",
			"language": "eng",
			"note": "PMID: 35121652\nPMCID: PMC9304114",
			"page": "599-608",
			"source": "PubMed",
			"title": "Evaluating patient-reported outcome measures in Peru: a cross-sectional study of satisfaction and net promoter score using the 2016 EnSuSalud survey",
			"title-short": "Evaluating patient-reported outcome measures in Peru",
			"volume": "31",
			"author": [
				{
					"family": "Leslie",
					"given": "Hannah H."
				},
				{
					"family": "Lee",
					"given": "Hwa-Young"
				},
				{
					"family": "Blouin",
					"given": "Brittany"
				},
				{
					"family": "Kruk",
					"given": "Margaret E."
				},
				{
					"family": "García",
					"given": "Patricia J."
				}
			],
			"issued": {
				"date-parts": [
					[
						"2022",
						8
					]
				]
			}
		},
		{
			"id": "http://zotero.org/users/5729767/items/ZQH9ETYR",
			"type": "article-journal",
			"abstract": "INTRODUCTION: Nearly 30 000 Mexican women develop breast cancer annually, frequently presenting unmet supportive care needs. In high-income countries, incorporating electronic patient-reported outcomes (ePROs) into cancer care has demonstrated potential for increasing patient-centred care and reducing unmet needs. No such ePRO interventions have been implemented in Mexico. This paper presents the study protocol for designing and evaluating an ePRO digital health application combined with proactive follow-up by nurses.\nMETHODS AND ANALYSIS: We designed a two-component intervention for women receiving breast cancer treatment: a responsive web application for monitoring ePROs and clinical algorithms guiding proactive follow-up by nurses. We will conduct a pilot test of the intervention with 50 patients with breast cancer for 6 weeks to assess feasibility and adjust the application. We will conduct a parallel arm randomised controlled trial assigning 205 patients each to intervention and control in one of Mexico's largest public oncology hospitals. The intervention will be provided for 6 months, with additional 3 months of post-intervention observation. The control group will receive usual healthcare and a list of breast cancer information sources. Women diagnosed with stages I, II or III breast cancer who initiate chemotherapy and/or radiotherapy will be invited to participate. The primary study outcome will be supportive care needs; secondary outcomes include global quality of life and breast symptoms. Information on the outcomes will be obtained through web-based self-administered questionnaires collected at baseline, 1, 3, 6 and 9 months.\nETHICS AND DISSEMINATION: The National Research and Ethics Committees of the Mexican Institute of Social Security approved the study (R-2021-785-059). Participants will sign an informed consent form prior to their inclusion. Findings will be disseminated through a policy brief to the local authorities, a webinar for patients, publications in peer-reviewed journals and presentations at national and international conferences.\nTRIAL REGISTRATION NUMBER: NCT05925257.",
			"container-title": "BMJ open",
			"DOI": "10.1136/bmjopen-2023-077322",
			"ISSN": "2044-6055",
			"issue": "11",
			"journalAbbreviation": "BMJ Open",
			"language": "eng",
			"note": "PMID: 37931967\nPMCID: PMC10632859",
			"page": "e077322",
			"source": "PubMed",
			"title": "Design and evaluation of a digital health intervention with proactive follow-up by nurses to improve healthcare and outcomes for patients with breast cancer in Mexico: protocol for a randomised clinical trial",
			"title-short": "Design and evaluation of a digital health intervention with proactive follow-up by nurses to improve healthcare and outcomes for patients with breast cancer in Mexico",
			"volume": "13",
			"author": [
				{
					"family": "Contreras Sánchez",
					"given": "Saúl Eduardo"
				},
				{
					"family": "Doubova",
					"given": "Svetlana V."
				},
				{
					"family": "Grajales Álvarez",
					"given": "Rocío"
				},
				{
					"family": "Dip Borunda",
					"given": "Abdel Krim"
				},
				{
					"family": "Martínez Pineda",
					"given": "Wendy Jazmín"
				},
				{
					"family": "Nuñez Cerrillo",
					"given": "Jose Gustavo"
				},
				{
					"family": "Silva Bravo",
					"given": "Fernando"
				},
				{
					"family": "Zalapa Velázquez",
					"given": "Rita"
				},
				{
					"family": "Gutiérrez De la Barrera",
					"given": "Marcos"
				},
				{
					"family": "Leslie",
					"given": "Hannah H."
				}
			],
			"issued": {
				"date-parts": [
					[
						"2023",
						11,
						6
					]
				]
			}
		},
		{
			"id": "http://zotero.org/users/5729767/items/GIYM6A99",
			"type": "article-journal",
			"abstract": "High-quality health systems must provide accessible, people-centred care to both improve health and maintain population trust in health services. Furthermore, accurate measurement of population perspectives is vital to hold health systems accountable and to inform improvement efforts. To describe the current state of such measures in Latin America and the Caribbean (LAC), we conducted a systematic review of facility and population-based assessments that included patient-reported experience and satisfaction measures. Five databases were searched for publications on quantitative surveys assessing healthcare quality in Spanish- or Portuguese-speaking LAC countries, focusing on the domains of processes of care and quality impacts. We included articles published since 2011 with a national sampling frame or inclusion of multiple subnational regions. We tabulated and described these articles, identifying, classifying and summarizing the items used to assess healthcare quality into the domains mentioned earlier. Of the 5584 publications reviewed, 58 articles met our inclusion criteria. Most studies were cross-sectional (95%), assessed all levels of healthcare (57%) and were secondary analyses of existing surveys (86%). The articles yielded 33 unique surveys spanning 12 LAC countries; only eight of them are regularly administered surveys. The most common quality domains assessed were satisfaction (in 33 out of 58 articles, 57%), evidence-based/effective care (34%), waiting times (33%), clear communication (33%) and ease of use (31%). Items and reported ratings varied widely among instruments used, time points and geographical settings. Assessment of patient-reported quality measures through population- and facility-based surveys is present but heterogeneous in LAC countries. Satisfaction was measured frequently, although its use in accountability or informing quality improvement is limited. Measurement of healthcare quality in LAC needs to be more systematic, regular, comprehensive and to be led collaboratively by researchers, governments and policymakers to enable comparison of results across countries and to effectively inform policy implementation.",
			"container-title": "Health Policy and Planning",
			"DOI": "10.1093/heapol/czad083",
			"ISSN": "0268-1080",
			"issue": "10",
			"journalAbbreviation": "Health Policy and Planning",
			"page": "1225-1241",
			"source": "Silverchair",
			"title": "A systematic review of population and patient perspectives and experiences as measured in Latin American and Caribbean surveys",
			"URL": "https://doi.org/10.1093/heapol/czad083",
			"volume": "38",
			"author": [
				{
					"family": "Medina-Ranilla",
					"given": "Jesús"
				},
				{
					"family": "Espinoza-Pajuelo",
					"given": "Laura"
				},
				{
					"family": "Mazzoni",
					"given": "Agustina"
				},
				{
					"family": "Roberti",
					"given": "Javier"
				},
				{
					"family": "García- Elorrio",
					"given": "Ezequiel"
				},
				{
					"family": "Leslie",
					"given": "Hannah Hogan"
				},
				{
					"family": "García",
					"given": "Patricia Jannet"
				}
			],
			"accessed": {
				"date-parts": [
					[
						"2024",
						8,
						15
					]
				]
			},
			"issued": {
				"date-parts": [
					[
						"2023",
						12,
						1
					]
				]
			}
		},
		{
			"id": "http://zotero.org/users/5729767/items/C2ILL99Z",
			"type": "article-journal",
			"abstract": "Todd Lewis and co-authors discuss development and use of the People’s Voice Survey for health system assessment.",
			"container-title": "PLOS Medicine",
			"DOI": "10.1371/journal.pmed.1004294",
			"ISSN": "1549-1676",
			"issue": "10",
			"journalAbbreviation": "PLOS Medicine",
			"language": "en",
			"note": "publisher: Public Library of Science",
			"page": "e1004294",
			"source": "PLoS Journals",
			"title": "Measuring people’s views on health system performance: Design and development of the People’s Voice Survey",
			"title-short": "Measuring people’s views on health system performance",
			"URL": "https://journals.plos.org/plosmedicine/article?id=10.1371/journal.pmed.1004294",
			"volume": "20",
			"author": [
				{
					"family": "Lewis",
					"given": "Todd P."
				},
				{
					"family": "Kapoor",
					"given": "Neena R."
				},
				{
					"family": "Aryal",
					"given": "Amit"
				},
				{
					"family": "Bazua-Lobato",
					"given": "Rodrigo"
				},
				{
					"family": "Carai",
					"given": "Susanne"
				},
				{
					"family": "Clarke-Deelder",
					"given": "Emma"
				},
				{
					"family": "Croke",
					"given": "Kevin"
				},
				{
					"family": "Dayalu",
					"given": "Rashmi"
				},
				{
					"family": "Espinoza-Pajuelo",
					"given": "Laura"
				},
				{
					"family": "Fink",
					"given": "Günther"
				},
				{
					"family": "Garcia",
					"given": "Patricia J."
				},
				{
					"family": "Garcia-Elorrio",
					"given": "Ezequiel"
				},
				{
					"family": "Getachew",
					"given": "Theodros"
				},
				{
					"family": "Jarhyan",
					"given": "Prashant"
				},
				{
					"family": "Kassa",
					"given": "Munir"
				},
				{
					"family": "Kim",
					"given": "Soon Ae"
				},
				{
					"family": "Mazzoni",
					"given": "Agustina"
				},
				{
					"family": "Medina-Ranilla",
					"given": "Jesus"
				},
				{
					"family": "Mohan",
					"given": "Sailesh"
				},
				{
					"family": "Molla",
					"given": "Gebeyaw"
				},
				{
					"family": "Moshabela",
					"given": "Mosa"
				},
				{
					"family": "Naidoo",
					"given": "Inbarani"
				},
				{
					"family": "Nzinga",
					"given": "Jacinta"
				},
				{
					"family": "Oh",
					"given": "Juhwan"
				},
				{
					"family": "Okiro",
					"given": "Emelda A."
				},
				{
					"family": "Prabhakaran",
					"given": "Dorairaj"
				},
				{
					"family": "Roberti",
					"given": "Javier"
				},
				{
					"family": "SteelFisher",
					"given": "Gillian"
				},
				{
					"family": "Taddele",
					"given": "Tefera"
				},
				{
					"family": "Tadele",
					"given": "Ashenif"
				},
				{
					"family": "Wang",
					"given": "Xiaohui"
				},
				{
					"family": "Xu",
					"given": "Roman"
				},
				{
					"family": "Leslie",
					"given": "Hannah H."
				},
				{
					"family": "Kruk",
					"given": "Margaret E."
				}
			],
			"accessed": {
				"date-parts": [
					[
						"2024",
						8,
						15
					]
				]
			},
			"issued": {
				"date-parts": [
					[
						"2023",
						10,
						6
					]
				]
			}
		},
		{
			"id": "http://zotero.org/users/5729767/items/SP63GNZI",
			"type": "article-journal",
			"container-title": "Nature Medicine",
			"DOI": "10.1038/s41591-024-03029-z",
			"ISSN": "1546-170X",
			"issue": "7",
			"journalAbbreviation": "Nat Med",
			"language": "en",
			"license": "2024 The Author(s), under exclusive licence to Springer Nature America, Inc.",
			"note": "publisher: Nature Publishing Group",
			"page": "1811-1812",
			"source": "www.nature.com",
			"title": "The QuEST LAC network uses data to promote evidence-based policies for health in Latin America",
			"URL": "https://www.nature.com/articles/s41591-024-03029-z",
			"volume": "30",
			"author": [
				{
					"family": "García",
					"given": "Patricia J."
				},
				{
					"family": "Leslie",
					"given": "Hannah"
				},
				{
					"family": "Medina-Ranilla",
					"given": "Jesús"
				},
				{
					"family": "Espinoza-Pajuelo",
					"given": "Laura"
				},
				{
					"family": "Guglielmino",
					"given": "Marina"
				},
				{
					"family": "Roberti",
					"given": "Javier"
				},
				{
					"family": "Mazzoni",
					"given": "Agustina"
				},
				{
					"family": "García-Elorrio",
					"given": "Ezequiel"
				}
			],
			"accessed": {
				"date-parts": [
					[
						"2024",
						8,
						15
					]
				]
			},
			"issued": {
				"date-parts": [
					[
						"2024",
						7
					]
				]
			}
		},
		{
			"id": "http://zotero.org/users/5729767/items/EHU5D7ZR",
			"type": "article-journal",
			"container-title": "The Lancet Global Health",
			"DOI": "10.1016/S2214-109X(23)00488-6",
			"ISSN": "2214-109X",
			"issue": "1",
			"journalAbbreviation": "The Lancet Global Health",
			"language": "English",
			"note": "publisher: Elsevier\nPMID: 38096887",
			"page": "e145-e155",
			"source": "www.thelancet.com",
			"title": "Inequalities in health system coverage and quality: a cross-sectional survey of four Latin American countries",
			"title-short": "Inequalities in health system coverage and quality",
			"URL": "https://www.thelancet.com/journals/langlo/article/PIIS2214-109X(23)00488-6/fulltext",
			"volume": "12",
			"author": [
				{
					"family": "Roberti",
					"given": "Javier"
				},
				{
					"family": "Leslie",
					"given": "Hannah H."
				},
				{
					"family": "Doubova",
					"given": "Svetlana V."
				},
				{
					"family": "Ranilla",
					"given": "Jesús Medina"
				},
				{
					"family": "Mazzoni",
					"given": "Agustina"
				},
				{
					"family": "Espinoza",
					"given": "Laura"
				},
				{
					"family": "Calderón",
					"given": "Renzo"
				},
				{
					"family": "Arsenault",
					"given": "Catherine"
				},
				{
					"family": "García-Elorrio",
					"given": "Ezequiel"
				},
				{
					"family": "García",
					"given": "Patricia J."
				}
			],
			"accessed": {
				"date-parts": [
					[
						"2024",
						8,
						15
					]
				]
			},
			"issued": {
				"date-parts": [
					[
						"2024",
						1,
						1
					]
				]
			}
		},
		{
			"id": "http://zotero.org/users/5729767/items/XFAHT9PF",
			"type": "article-journal",
			"container-title": "The Lancet Global Health",
			"DOI": "10.1016/S2214-109X(23)00490-4",
			"ISSN": "2214-109X",
			"issue": "1",
			"journalAbbreviation": "The Lancet Global Health",
			"language": "English",
			"note": "publisher: Elsevier\nPMID: 38096888",
			"page": "e156-e165",
			"source": "www.thelancet.com",
			"title": "Health system quality and COVID-19 vaccination: a cross-sectional analysis in 14 countries",
			"title-short": "Health system quality and COVID-19 vaccination",
			"URL": "https://www.thelancet.com/journals/langlo/article/PIIS2214-109X(23)00490-4/fulltext",
			"volume": "12",
			"author": [
				{
					"family": "Arsenault",
					"given": "Catherine"
				},
				{
					"family": "Lewis",
					"given": "Todd P."
				},
				{
					"family": "Kapoor",
					"given": "Neena R."
				},
				{
					"family": "Okiro",
					"given": "Emelda A."
				},
				{
					"family": "Leslie",
					"given": "Hannah H."
				},
				{
					"family": "Armeni",
					"given": "Patrizio"
				},
				{
					"family": "Jarhyan",
					"given": "Prashant"
				},
				{
					"family": "Doubova",
					"given": "Svetlana V."
				},
				{
					"family": "Wright",
					"given": "Katherine D."
				},
				{
					"family": "Aryal",
					"given": "Amit"
				},
				{
					"family": "Kounnavong",
					"given": "Sengchanh"
				},
				{
					"family": "Mohan",
					"given": "Sailesh"
				},
				{
					"family": "Odipo",
					"given": "Emily"
				},
				{
					"family": "Lee",
					"given": "Hwa-Young"
				},
				{
					"family": "Shin",
					"given": "Jeonghyun"
				},
				{
					"family": "Ayele",
					"given": "Wondimu"
				},
				{
					"family": "Medina-Ranilla",
					"given": "Jesús"
				},
				{
					"family": "Espinoza-Pajuelo",
					"given": "Laura"
				},
				{
					"family": "Mebratie",
					"given": "Anagaw Derseh"
				},
				{
					"family": "Elorrio",
					"given": "Ezequiel García"
				},
				{
					"family": "Mazzoni",
					"given": "Agustina"
				},
				{
					"family": "Oh",
					"given": "Juhwan"
				},
				{
					"family": "SteelFisher",
					"given": "Gillian K."
				},
				{
					"family": "Tarricone",
					"given": "Rosanna"
				},
				{
					"family": "Kruk",
					"given": "Margaret E."
				}
			],
			"accessed": {
				"date-parts": [
					[
						"2024",
						8,
						15
					]
				]
			},
			"issued": {
				"date-parts": [
					[
						"2024",
						1,
						1
					]
				]
			}
		},
		{
			"id": "http://zotero.org/users/5729767/items/LBT6NGSZ",
			"type": "article-journal",
			"abstract": "OBJECTIVE: The Mexican government has pursued multiple initiatives to improve healthcare coverage and financial protection. Yet, out-of-pocket health spending and use of private sector providers in Mexico remains high. In this paper, we sought to describe the characteristics of public and private healthcare users, describe recent visit quality across provider types, and to assess whether perceiving the public healthcare sector as poor quality is associated with private health sector use.\nMETHODS AND FINDINGS: We analyzed the cross-sectional People's Voice Survey conducted from December 2022 to January 2023. We used Chi-square tests to compare contextual, individual, and need-for-care factors and ratings of most recent visits between users of public (social security and other public providers) and private sector providers (stand-alone private providers and providers adjacent to pharmacies). We used a multivariable Poisson regression model to assess associations between low ratings of public healthcare sources and the use of private care. Among the 811 respondents with a healthcare visit in the past year, 31.2% used private sources. Private healthcare users were more educated and had higher incomes than public healthcare users. Quality of most recent visit was rated more highly in private providers (70.2% rating the visit as excellent or very good for stand-alone private providers and 54.3% for pharmacy-adjacent doctors) compared to social security (41.6%) and other public providers (46.6%). Those who perceived public health institutions as low quality had a higher probability of seeking private healthcare.\nCONCLUSION: Users rated public care visits poorly relative to private care; at the population level, perceptions of poor quality care may drive private care use and hence out-of-pocket costs. Improving public healthcare quality is necessary to ensure universal health coverage.",
			"container-title": "PloS One",
			"DOI": "10.1371/journal.pone.0306179",
			"ISSN": "1932-6203",
			"issue": "6",
			"journalAbbreviation": "PLoS One",
			"language": "eng",
			"note": "PMID: 38917130\nPMCID: PMC11198766",
			"page": "e0306179",
			"source": "PubMed",
			"title": "Users' perception of quality as a driver of private healthcare use in Mexico: Insights from the People's Voice Survey",
			"title-short": "Users' perception of quality as a driver of private healthcare use in Mexico",
			"volume": "19",
			"author": [
				{
					"family": "Doubova",
					"given": "Svetlana V."
				},
				{
					"family": "Leslie",
					"given": "Hannah H."
				},
				{
					"family": "Pérez-Cuevas",
					"given": "Ricardo"
				},
				{
					"family": "Kruk",
					"given": "Margaret E."
				},
				{
					"family": "Arsenault",
					"given": "Catherine"
				}
			],
			"issued": {
				"date-parts": [
					[
						"2024"
					]
				]
			}
		},
		{
			"id": "http://zotero.org/users/5729767/items/B8KEB9MN",
			"type": "article-journal",
			"abstract": "OBJECTIVES: This study aimed to explore the acceptability, feasibility, usability, and preliminary effect of an electronic patient-reported outcome (ePRO) intervention for patients with breast cancer in Mexico.\nDESIGN: We conducted a multimethod non-randomised pilot study. We used a pre-test/post-test design for quantitative assessment of the intervention's effect on patients' supportive care needs and quality of life. We conducted in-depth interviews (IDIs) with participants and healthcare workers to explore the intervention's benefits and barriers and understand its feasibility.\nPARTICIPANTS: 50 women aged 20-75 diagnosed with stage I-III breast cancer were enrolled within 2 weeks of starting neoadjuvant or adjuvant treatment with chemotherapy or radiotherapy. We excluded illiterate women and those with visual impairment, cognitive disability or severe depression. IDIs were conducted with 18 participants and 10 healthcare providers.\nSETTING: Oncology services in three public hospitals of the Mexican Social Security Institute.\nINTERVENTION: The ePRO intervention consisted of a responsive web application for weekly symptom reporting combined with proactive follow-up by nurses guided by predefined clinical algorithms for 6 weeks.\nRESULTS: 50 women were enrolled out of 66 eligible patients approached (75.8%). All 50 completed the 4-week follow-up assessment (100% retention). Completion of the symptom registry declined from 100% in week 1 to 66% in week 6. Participants experienced decreases in supportive care needs and increased quality of life. The ePRO application was rated highly usable. Participants and health professionals both perceived intervention benefits. Drawbacks included poor fit for women receiving radiotherapy and challenges using the application for women with low digital literacy or experiencing severe symptoms.\nCONCLUSIONS: This pilot study provided evidence of the high usability and potential efficacy of a web-based ePRO intervention. We revised recruitment during the pilot to include multiple facilities, and we will further revise for the randomised trial to address barriers to successful ePRO implementation.\nTRIAL REGISTRATION NUMBER: ClinicalTrials.gov ID: NCT05925257.",
			"container-title": "BMJ open",
			"DOI": "10.1136/bmjopen-2024-087240",
			"ISSN": "2044-6055",
			"issue": "6",
			"journalAbbreviation": "BMJ Open",
			"language": "eng",
			"note": "PMID: 38908841",
			"page": "e087240",
			"source": "PubMed",
			"title": "Addressing the unmet needs of women with breast cancer in Mexico: a non-randomised pilot study of the digital ePRO intervention",
			"title-short": "Addressing the unmet needs of women with breast cancer in Mexico",
			"volume": "14",
			"author": [
				{
					"family": "Contreras Sánchez",
					"given": "Saúl Eduardo"
				},
				{
					"family": "Doubova",
					"given": "Svetlana V."
				},
				{
					"family": "Martinez Vega",
					"given": "Ingrid Patricia"
				},
				{
					"family": "Grajales Álvarez",
					"given": "Rocío"
				},
				{
					"family": "Villalobos Valencia",
					"given": "Ricardo"
				},
				{
					"family": "Dip Borunda",
					"given": "Abdel Karim"
				},
				{
					"family": "Lio Mondragón",
					"given": "Lorena"
				},
				{
					"family": "Martínez Pineda",
					"given": "Wendy Jazmín"
				},
				{
					"family": "Nuñez Cerrillo",
					"given": "Jose Gustavo"
				},
				{
					"family": "Huerta López",
					"given": "Alma Diana"
				},
				{
					"family": "Zalapa Velázquez",
					"given": "Rita"
				},
				{
					"family": "Mendoza Ortiz",
					"given": "Valeria"
				},
				{
					"family": "Vázquez Zamora",
					"given": "Víctor Javier"
				},
				{
					"family": "Montiel Jarquín",
					"given": "Álvaro José"
				},
				{
					"family": "García Galicia",
					"given": "Arturo"
				},
				{
					"family": "Talamantes Gómez",
					"given": "Enrique Isay"
				},
				{
					"family": "Sánchez Reyes",
					"given": "Roberto"
				},
				{
					"family": "Aguirre Gómez",
					"given": "Jaqueline"
				},
				{
					"family": "Ayala Anzures",
					"given": "María Eugenia"
				},
				{
					"family": "Zapata Tarrés",
					"given": "Marta"
				},
				{
					"family": "Monroy",
					"given": "Adriana"
				},
				{
					"family": "Leslie",
					"given": "Hannah H."
				}
			],
			"issued": {
				"date-parts": [
					[
						"2024",
						6,
						21
					]
				]
			}
		},
		{
			"id": "http://zotero.org/users/5729767/items/AGDYUXQD",
			"type": "article-journal",
			"abstract": "BACKGROUND: The Latin American region demonstrates the lowest levels of trust in health systems globally. Institutional corruption is a major factor in eroding trust. Corruption in health services, including extracting bribes and informal payments from patients, directly harms health outcomes and weakens services intended as public goods. In this study, we aim to characterize the frequency and distribution of informal payments within public health services in Peru.\nMETHODS: We conducted a secondary analysis of a nationally representative cross-sectional survey, the 2018 National Household Survey of Living Conditions and Poverty, and identified all individuals reporting health insurance from the Ministry of Health (SIS-MINSA) or Social Security (ESSALUD). We defined self-reported informal payments in 2 ways: 1) being asked to pay a bribe at a health establishment in the past year (direct method), and 2) creating an overall indicator for non-zero cost of care for services that should be free (indirect method). We used descriptive statistics to quantify informal payments and bivariate analysis to identify sociodemographic characteristics of those most frequently reporting such payments.\nFINDINGS: 132,355 people were surveyed, including 69,839 (52.8%) with coverage from SIS-MINSA and 30,461 (23.03%) from ESSALUD. Less than 1% of participants directly reported informal payments, either at SIS-MINSA services (0.22%); or at ESSALUD (0.42%). Indirect reporting was more prevalent, including up to 10% of surgery patients and 17% of those hospitalized in SIS-MINSA facilities. Wealthier patients (19%) were more likely to report such payments.\nINTERPRETATION: While direct reporting of bribery was uncommon, we found moderate prevalence of informal payments in public health services in Peru using an indirect assessment method. Indirect reporting may exceed direct reporting due to difficulty in distinguishing appropriate and inappropriate payments, fear of reporting health care workers' behavior, or social tolerance of informal payments. Informal payments were more common among those with greater financial capital, indicating they may obtain enhanced services. Further research on patients' perception and reporting of informal payments is a key step towards accurate measurement and evidence-based intervention.",
			"container-title": "PLOS global public health",
			"DOI": "10.1371/journal.pgph.0001837",
			"ISSN": "2767-3375",
			"issue": "1",
			"journalAbbreviation": "PLOS Glob Public Health",
			"language": "eng",
			"note": "PMID: 38241208\nPMCID: PMC10798543",
			"page": "e0001837",
			"source": "PubMed",
			"title": "Informal payments in health facilities in Peru in 2018: Analysis of a cross-sectional survey",
			"title-short": "Informal payments in health facilities in Peru in 2018",
			"volume": "4",
			"author": [
				{
					"family": "Espinoza-Pajuelo",
					"given": "Laura"
				},
				{
					"family": "Mallma",
					"given": "Patricia"
				},
				{
					"family": "Leslie",
					"given": "Hannah Hogan"
				},
				{
					"family": "García",
					"given": "Patricia Jannet"
				}
			],
			"issued": {
				"date-parts": [
					[
						"2024"
					]
				]
			}
		}
	],
}


//PublicationsPublications[0]["author"][0]["family"]

export default Publications;